import { Box, Typography } from '@mui/material'
import dogImage from '../../assets/dog_sitting.png'
import landlordAvatar from '../../assets/landlord_avatar.jpg'

export default function AIConversationFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Status Bar */}
        <Box sx={{
          height: 44,
          bgcolor: '#006AFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2
        }}>
          <Typography
            variant="h6"
            sx={{
              color: 'white',
              fontWeight: 700,
              fontSize: '1.25rem',
              letterSpacing: '0.5px'
            }}
          >
            Zillow
          </Typography>
        </Box>

        {/* Conversation Area */}
        <Box sx={{
          p: 2,
          height: 'calc(100% - 44px)',
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}>
          {/* AI Message 1 */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <Box
              component="img"
              src={dogImage}
              alt="AI"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
            <Box sx={{
              bgcolor: 'grey.100',
              borderRadius: '18px',
              borderTopLeftRadius: '4px',
              p: 1.5,
              maxWidth: '80%'
            }}>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4, color: 'grey.900' }}>
                Hi there, I have someone interested your  pet friendly two bedroom home. <br /> Is it still available?
              </Typography>
            </Box>
          </Box>

          {/* Landlord Message */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <Box sx={{
              bgcolor: '#fbbf24',
              borderRadius: '18px',
              borderTopRightRadius: '4px',
              p: 1.5,
              maxWidth: '80%'
            }}>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4, color: 'grey.900' }}>
                Yes it is
              </Typography>
            </Box>
            <Box
              component="img"
              src={landlordAvatar}
              alt="Landlord"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          </Box>

          {/* AI Message 2 */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <Box
              component="img"
              src={dogImage}
              alt="AI"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
            <Box sx={{
              bgcolor: 'grey.100',
              borderRadius: '18px',
              borderTopLeftRadius: '4px',
              p: 1.5,
              maxWidth: '80%'
            }}>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4, color: 'grey.900' }}>
                 Great! Here is their profile. You can request a time for them to come see the place.
               </Typography>
               <Typography
                 variant="body2"
                 component="span"
                 sx={{
                   fontSize: '0.875rem',
                   lineHeight: 1.4,
                   color: '#1976d2',
                   textDecoration: 'underline',
                   cursor: 'pointer'
                 }}
               >
                 HeyyProperty Profile
               </Typography>
            </Box>
          </Box>

          {/* Landlord Message 2 */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <Box sx={{
              bgcolor: '#fbbf24',
              borderRadius: '18px',
              borderTopRightRadius: '4px',
              p: 1.5,
              maxWidth: '80%'
            }}>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4, color: 'grey.900' }}>
                They seem nice
              </Typography>
            </Box>
            <Box
              component="img"
              src={landlordAvatar}
              alt="Landlord"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          </Box>

          {/* Landlord Message 3 */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <Box sx={{
              bgcolor: '#fbbf24',
              borderRadius: '18px',
              borderTopRightRadius: '4px',
              p: 1.5,
              maxWidth: '80%'
            }}>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4, color: 'grey.900' }}>
                Sent a request for Saturday at 1 pm.
              </Typography>
            </Box>
            <Box
              component="img"
              src={landlordAvatar}
              alt="Landlord"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

